import React from 'react'
import { Header } from '../components'

const HeaderOnlyLayout = ({children}) => {
  return (
    <React.Fragment>
      <Header />
      {children}
    </React.Fragment>
  )
}

export { HeaderOnlyLayout }